module.exports = __webpack_public_path__ + "img/youpaq-logo-home.33260c03.png";